<template>
    <div>
        <div id="viewDiv">
        </div>
        <div v-if="mapConfig.showToolbar" id="toolbar">
            <div style="display: inline;">
                <div id="basemapDiv" class="mapTool" ></div>
                <div id="legendDiv" class="mapTool" ></div>
            </div>
            <span class="toolbar-spacer"></span>
            <button :class="{'action-button': true, 'esri-icon-checkbox-unchecked': true, 'action-button-toggle': rectangleSelect}" id="rectangleButton" type="button"
                title="Select features"></button>
            <button :class="{'action-button': true, 'esri-icon-collection': true, 'action-button-toggle': multiSelect}" id="multiselectButton" type="button"
                title="Toggle Multi-Select"></button>
            <button class="action-button esri-icon-close" id="clearButton" type="button" title="Clear selection"></button>
        </div>
    </div>
</template>
<script>
    import { loadModules } from 'esri-loader';

    export default {
        props: [
            'checkedLayers', 'selectedFeature', 'configName', 'selectionData', 'smallLayout', 'facilityIds', 'listLane',
            'domains', 'configReady', 'mapConfig', 'searchValue', 'customQuery', 'resetView', 'externalData', 'ieEleven'
        ],
        methods: {
            selectedFeatureChange (newVal) {
                if (newVal) {
                    this.map.findLayerById("highlightLayer").graphics.removeAll();
                    this.highlightFeature(newVal);
                    this.view.popup.dockEnabled = this.mapConfig.defaultDocked;
                    this.$emit('search-complete', newVal.attributes);
                } // if
            },
            addFeatures(features) {
                let layerName = "resultLayer";
                features.push(...this.map.findLayerById(layerName).graphics.items);
                this.map.findLayerById(layerName).graphics.removeAll();

                for (let i = 0; i < features.length; i++) {
                    features[i].symbol = this.getSymbolFromGeometry(features[i].geometry, layerName);
                    if (features[i].layer && !features[i].attributes.layerId)
                        features[i].attributes.layerId = features[i].layer.id;
                    if (this.mapConfig.externalDataMap[features[i].attributes.layerId]) {
                        let dataMap = this.mapConfig.externalDataMap[features[i].attributes.layerId];
                        
                        for (let extIdx = 0; extIdx < this.externalData.length; extIdx++) {
                            if (this.externalData[extIdx][dataMap.primaryField] === features[i].attributes.ID.toString()) {
                                for (let field in dataMap.fields) {
                                    features[i].attributes[field] = this.externalData[extIdx][dataMap.fields[field]];
                                } // for
                            } // if
                        } // for
                    } // if
                    features[i].popupTemplate = this.mapConfig.templates[features[i].attributes.layerId];
                    if (!features[i].popupTemplate)
                        features[i].popupTemplate = this.mapConfig.templates.searchTemplate;
                    this.map.findLayerById(layerName).add(features[i]);
                } // for
                
                if (features.length > 0) {
                    // this.highlightFeature(features[0]);
                    if (features[0].popupTemplate) {
                        this.view.popup.viewModel.features = features;
                        this.view.popup.set("visible", true);
                    } // if
                } // if
            },
            highlightFeature(feature) {
                this.addHighlights([feature]);
                
                if (this.gotoHighlight) {
                    this.view.goTo({ target: feature, scale: this.mapConfig.highlightScale }, {animate: true});
                } // if
            },
            addHighlights(features, layerName, setPopup) {
                if (!layerName)
                    layerName = "highlightLayer";
                if (setPopup === undefined)
                    setPopup = true;

                let layer = this.map.findLayerById(layerName);

                features.forEach( feature => {
                    let newFeature = feature.clone();
                    newFeature.symbol = this.getSymbolFromGeometry(newFeature.geometry, layerName);
                    if (setPopup)
                        this.setPopupLocation(newFeature.geometry);
                    layer.add(newFeature);
                });
            },
            getSymbolFromGeometry(geometry, layerName) {
                if (!layerName || !this.mapConfig.colors[layerName])
                    layerName = "default";
                
                let lineColor = this.mapConfig.colors[layerName].line;
                let fillColor = this.mapConfig.colors[layerName].fill;

                if (geometry.type === "point") {
                    return {
                        type: "simple-marker",  // autocasts as SimpleLineSymbol()
                        color: fillColor, // Color for search selections
                        width: 4
                    };
                } // if
                else if (geometry.type === "polyline") {
                    return {
                        type: "simple-line",  // autocasts as SimpleLineSymbol()
                        color: lineColor, // Color for search selections
                        width: 2
                    };
                } // else if
                else {
                    return {
                        type: "simple-fill",
                        color: fillColor,
                        outline: {
                            type: "simple-line",  // autocasts as SimpleLineSymbol()
                            color: lineColor, // Color for search selections
                            width: 2
                        }
                    };
                } // else
            },
            setPopupLocation(geometry) {
                if (geometry.type === "point")
                    this.view.popup.viewModel.location = geometry;
                else
                    this.view.popup.viewModel.location = geometry.extent.center;
            },
            async layerQuery(layer, query) {
                let queryData;

                try {
                    queryData = await layer.queryFeatures(query).catch( err => { throw err });
                    return queryData.features;
                } // try
                catch (err) {
                    console.log(err);
                } // catch

                return [];
            },
            async queryVisibleLayers(query) {
                let index = 0;
                let results = [];
                let currLayer;

                for (index = 0; index < this.checkedLayers.length; index++) {
                    if (this.mapConfig.layerDefs[this.checkedLayers[index]][query.xType]) {
                        currLayer = this.map.findLayerById(this.checkedLayers[index]);
                        results = results.concat(await this.layerQuery(currLayer, query));
                    } // if
                } // for

                return results;
            },
            async queryLayer(query, layer) {
                let results = [];
                let currLayer;

                currLayer = this.map.findLayerById(layer);
                results = await this.layerQuery(currLayer, query);
                
                return results;
            },
            async findFeatures(query, layer) {
                let results;
                
                if (layer) {
                    results = await this.queryLayer(query, layer);
                } // if
                else {
                    results = await this.queryVisibleLayers(query);
                } // else
                    
                if (!this.multiSelect) {
                    this.searchClear();
                } // if
                this.addFeatures(results);
            },
            mapClick(evt) {
                if (evt.type === "click" && this.view.scale <= 10000) {
                    let query = {
                        units: "meters",
                        distance: this.mapConfig.mapClickTolerance,
                        geometry: evt.mapPoint,
                        outFields: ["*"],
                        returnGeometry: true,
                        xType: "selectable"
                    };

                    this.findFeatures(query);
                } // if
            },
            async queryFacilityIds() {
                if (this.facilityIds.length > 0) {
                    let idArray = this.facilityIds.map( element => "'" + element.ENTITYUID + "'" );
                    let query = {
                        where: "FacilityId in (" + idArray.join(",") + ")",
                        outFields: ["OBJECTID"],
                        returnGeometry: true
                    };
                    let layer = this.map.findLayerById('backlaneLayer');
                    let queryData = await layer.queryFeatures(query).catch( err => { console.log(err) });
                    return queryData.features;
                } // if

                return [];
            },
            async addActivityFeatures(FeatureLayer) {
                let layerName = "activityLayer";
                let activityFeatures = await this.queryFacilityIds();
                if (activityFeatures.length > 0) {
                    let activityLayer = new FeatureLayer({
                        title: "Work Activity",
                        layerId: layerName,
                        geometryType: "polyline",
                        objectIdField: "OBJECTID",
                        source: activityFeatures,
                        renderer: {
                            type: "simple",
                            symbol: this.getSymbolFromGeometry(activityFeatures[0].geometry, layerName),
                            label: "Work done in current calendar year"
                        }
                    });
                    // activityLayer.source = activityFeatures;
                    this.map.add(activityLayer);
                    this.map.reorder(activityLayer, 4);
                } // if
            },
            selectFeatures(event) {
                let query = {};
                if (event.type === "create") {
                    switch (event.state) {
                        case "complete":
                            query.geometry = event.graphic.geometry;
                            query.outFields = ["*"];
                            query.returnGeometry = true;
                            query.xType = "selectable";

                            this.rectangleSelect = false;

                            this.findFeatures(query);
                            break;
                        case "cancel":
                            this.rectangleSelect = false;
                            break;
                        default:
                            break;
                    } // switch
                } // if
            },
            rankFeatures(features, searchTerm) {
                for (let feature of features) {
                    if (feature.attributes["BrandonGIS.SDE.ownership.BROLL"].toString() === searchTerm) {
                        feature.rank = 100;
                    } // if
                    else if (feature.attributes["BrandonGIS.sde.OPENDATA_JSON_TAC.ADDRESS"].toString() === searchTerm) {
                        feature.rank = 90;
                    } // else if
                    else if (feature.attributes["BrandonGIS.sde.OPENDATA_JSON_TAC.ADDRESS"].toString().substring(0,searchTerm.length) === searchTerm) {
                        feature.rank = 80;
                    } // else if
                    else {
                        feature.rank = 1;
                    } // else
                } // for..of

                return features.sort( (a,b) => b.rank - a.rank);
            },
            processSearchAttributes(match, results)
            {
                let attributes = {
                    layerId: this.mapConfig.searchMap.layerId,
                    related: [],
                    combine: ""
                };
                let set = {};

                // attributes[this.mapConfig.searchMap.name] = match.name;
                
                for (let i = 0; i < results.length; i++)
                {
                    let layerId = results[i].layer.id;
                    let attribs = this.mapConfig.searchMap.layers[layerId];
                    attributes.related.push(results[i].attributes);
                    if (attribs.combineField)
                        attributes.combine += results[i].attributes[attribs.combineField] + "<br/>";

                    if (attribs.type === "contains")
                        set[layerId] = results[i].geometry.extent.contains(match.geometry.extent.center);
                    else if (attribs.type === "closest" && !set[layerId])
                        set[layerId] = true;
                    else
                        set[layerId] = false;
                    
                    if (set[layerId]) {
                        for (let j = 0; j < attribs.fields.length; j++) {
                            if (typeof attribs.fields[j] === "object") {
                                switch (attribs.fields[j].type) {
                                    case "date":
                                        attributes[attribs.fields[j].field] = new Date(results[i].attributes[attribs.fields[j].field]).toISOString().split('T')[0];
                                        break;
                                    default:
                                        break;
                                } // switch
                            } //if
                            else if (this.domains[attribs.fields[j]])
                                attributes[attribs.fields[j]] = this.domains[attribs.fields[j]][results[i].attributes[attribs.fields[j]]];
                            else
                                attributes[attribs.fields[j]] = results[i].attributes[attribs.fields[j]];
                        } // for
                    } // if
                } // for

                return attributes;
            },
            async querySearchLayers(query) {
                let results = [];
                let currLayer;
                let searchMap = this.mapConfig.searchMap;

                for (let layerName in searchMap.layers) {
                    currLayer = this.map.findLayerById(layerName);
                    // Run query for related features on every layer in searchMap
                    let queryResults = await this.layerQuery(currLayer, query);
                    // Filter features if defined in searchMap
                    let filters = searchMap.layers[layerName].filters;
                    if (filters) {
                        queryResults = queryResults.filter( result => {
                            let match = false;
                            filters.forEach( filter => {
                                filter.values.forEach( value => {
                                    if (result.attributes[filter.field] === value)
                                        match = true;
                                })
                            });
                            return match;
                        });
                    } // if
                    // Combine results from all layer queries
                    results = results.concat(queryResults);
                } // for

                return results;
            },
            async findRelatedFeatures(match) {
                let query = {
                    units: "meters",
                    distance: "10",
                    geometry: match.geometry,
                    outFields: ["*"],
                    returnGeometry: true,
                    xType: "searchable"
                };

                // Query layers in searchMap to find related features
                let findResults = await this.querySearchLayers(query);
                // Assign attributes to match from related features
                Object.assign(match.attributes, this.processSearchAttributes(match,findResults));

                return findResults;
            },
            async searchComplete({ numResults, results, searchTerm, errors }) {
                console.log(errors);
                if (numResults > 0) {
                    // Map sub-results and flatten to single array then
                    // map just features property to array
                    let features = results.map( result => result.results );
                    let flatFeatures = [];
                    for (let feat of features) {
                        flatFeatures.push(...feat);
                    } // for
                    features = flatFeatures.map( match => match.feature );

                    // Rank features (primarily so roll number matches show up first)
                    let rankedFeatures = this.rankFeatures(features, searchTerm);

                    // Use highest ranked match and find related features
                    let relatedFeatures = await this.findRelatedFeatures(rankedFeatures[0]);

                    this.searchClear();
                    this.gotoHighlight = true;

                    // Add highest ranked feature and all related features to map
                    if (this.mapConfig.searchMap.allResults)
                        this.addFeatures([rankedFeatures[0], ...relatedFeatures]);
                    // Add highest ranked feature and only higlight related features
                    else {
                        this.addFeatures([rankedFeatures[0]]);
                        this.addHighlights(relatedFeatures, "relatedLayer");
                    } // else

                    // this.view.popup.dockEnabled = this.mapConfig.defaultDocked;
                } // if
            },
            clearClick() {
                this.search.searchTerm = '';
                this.searchClear(null);
            },
            searchClear() {
                this.gotoHighlight = false;
                this.mapConfig.graphicsLayers.forEach( layerDef => {
                    this.map.findLayerById(layerDef.id).removeAll();
                });
                this.view.popup.set("visible", false);
                this.$emit('search-clear');
            },
            async runCustomQuery(val) {
                if (val > -1 && val < this.mapConfig.customQueries.length) {
                    let query = {
                        where: this.mapConfig.customQueries[val].where,
                        outFields: ["*"],
                        returnGeometry: true,
                        outSpatialReference: this.view.spatialReference
                    };

                    await this.findFeatures(query, this.mapConfig.customQueries[val].layer);
                    
                    this.$emit('custom-query-complete');
                } // if
            },           
            setVisibility(visible, layers)
            {
                // ***FIX*** THIS GRABS THE SAME map-image LAYER MULTIPLE TIMES
                for (let i = 0; i < layers.length; i++) {
                    let layer = this.getLayer(this.mapConfig.layerDefs[layers[i]].layerName);
                    if (layer.type === "map-image") {
                        if (layer.sublayers.length > 0) {
                            this.getSublayer(layer, this.mapConfig.layerDefs[layers[i]].subindex).visible = visible;
                        } // if
                    } // if
                    else {
                        layer.visible = visible;
                    } // else
                } // for
            },
            setLayers(val, oldVal) {
                if (this.map) {
                    if (!oldVal)
                        oldVal = [];
                    if (!val)
                        val = [];
                    
                    let hideLayers = oldVal.filter(e => !val.indexOf(e) > -1);
                    let showLayers = val.filter(e => !oldVal.indexOf(e) > -1);
                    
                    this.setVisibility(false, hideLayers);
                    this.setVisibility(true, showLayers);
                } // if
            },
            listSelect(lane) {
                if (this.map) {
                    this.map.findLayerById("listLayer").removeAll();

                    if (!lane.active) {
                        let layer = this.map.findLayerById("relatedLayer");
                        let listFeature = null;


                        layer.graphics.forEach( graphic => {
                            if (graphic.attributes.OBJECTID === lane.OBJECTID)
                                listFeature = graphic.clone();
                        });
                        
                        
                        if (listFeature !== null) {
                            listFeature.symbol.color = this.mapConfig.colors["listLayer"];
                            listFeature.symbol.width = 4;
                            this.addHighlights([listFeature], "listLayer", false);
                        } // if
                    } // if

                    this.$emit("list-highlight-complete", lane);
                } // if
            },
            getObjectidField(feature) {
                let fieldNames = ["OBJECTID", "OBJECTID_1", "OBJECTID_12"];

                for (let i = 0; i < fieldNames.length; i++) {
                    if (feature.attributes[fieldNames[i]]) {
                        return fieldNames[i];
                    } // if
                } // for

                return null;
            },
            getLayer(layerName) {
                return this.map.findLayerById(layerName);
            },
            getSublayer(layer, subindex) {
                return layer.sublayers.items[subindex];
            },
            runSearch(val) {
                if (val !== "") {
                    // do search with val
                    this.search.searchTerm = val;
                    this.search.search();
                } // if
            },
            defaultView(val) {
                if (val) {
                    this.view.center = [this.mapConfig.view.center.x, this.mapConfig.view.center.y];
                    this.view.zoom = this.mapConfig.view.zoom;
                    this.searchClear();
                    this.$emit('reset-complete');
                } // if
            },
            setCustomExportElements(val) {
                // * BAD!!! *
                // Should be outside ArcgisMap component

                const measMap = new Map();
                measMap.set('dPROPMEASLOT','dPROPMEASTYPELOT');
                measMap.set('daPROPMEASFRONT_1','daPRPMEASTYPFRNT_1');
                measMap.set('daPROPMEASFRONT_3','daPRPMEASTYPFRNT_3');

                const result = Object.keys(val).map((key) => {
                    let newObj = {};
                    let measVal = measMap.get(key);
                    if (measVal) {
                        newObj[key] = this.$formatMeas(val[key], measVal, val[measVal]);
                    } // if
                    else {
                        newObj[key] = val[key].toString();
                    } // else
                    return newObj;
                });
                
                // * BAD!!! *
                // Should be specifying the arrays to assign outside the map component
                // Maybe use a customExport prop set by the parent instead of selectionData

                let addDatasets = [
                    this.$dataFilter(val['yearlyTaxes'], 'TAX_YEAR'),
                    val['assessments'],
                    val['certsOfTitle']
                ];

                for (let dataset = 0; dataset < addDatasets.length; dataset++) {
                    let currData = addDatasets[dataset];

                    for (let i = 0; i < currData.length; i++) {
                        for (let key in currData[i]) {
                            let newObj = {};
                            let currValue = this.$mapValue(currData[i][key], key);
                            
                            if (typeof(currValue) === "number") {
                                newObj[key + '_' + i] = this.$formatCurr(currValue);
                            } // if
                            else {
                                newObj[key + '_' + i] = currValue;
                            } // else

                            result.push(newObj);
                        } // for
                    } // for
                } // for

                this.print.templateOptions.customTextElements = result;
            },
            async loadMap() {
                 // first, we use Dojo's loader to require the map class
                console.log("Load map...");
                const [esriConfig, MapView, EsriMap, FeatureLayer, GraphicsLayer, MapImageLayer, Legend, Search, Expand,
                    SketchViewModel, BasemapGallery, QueryTask, Query] = 
                await loadModules([
                    'esri/config',
                    'esri/views/MapView',
                    'esri/Map',
                    'esri/layers/FeatureLayer',
                    'esri/layers/GraphicsLayer',
                    'esri/layers/MapImageLayer',
                    'esri/widgets/Legend',
                    'esri/widgets/Search',
                    'esri/widgets/Expand',
                    'esri/widgets/Sketch/SketchViewModel',
                    'esri/widgets/BasemapGallery',
                    'esri/tasks/QueryTask',
                    'esri/tasks/support/Query'
                ], { url: this.mapConfig.apiUrl }).catch(err => { console.error(err); });

                esriConfig.request.timeout = this.mapConfig.timeout;
                // esriConfig.apiKey = "AAPK4b8a82d4dc4f41b296141775d96a45d4rU-xJvs4iSzT0CsB1D1A1ICo0Pq99zEY693JA98G8OrujIRv7OZeMxeX4oqGEgF-";

                this.map  = new EsriMap({
                    basemap: this.mapConfig.basemap
                });

                // Add visible and selectable/searchable layers
                this.mapConfig.layers.forEach( layerDef => {
                    let layer;

                    if (layerDef.type === "map-image") {
                        layer = new MapImageLayer(layerDef.data);
                    } // if
                    else {
                        layer = new FeatureLayer(layerDef.data);
                    } // else

                    this.map.add(layer);
                });

                // Add graphics layers for results, highlights, etc...
                this.mapConfig.graphicsLayers.forEach( layer => {
                    this.map.add(new GraphicsLayer(layer));
                });
                
                this.queryTask = new QueryTask(this.mapConfig.queryTask);

                this.query = new Query(this.mapConfig.query);

                // Set currently checkedLayers and remove previously checked layers
                this.setLayers(this.checkedLayers);

                this.view = new MapView({
                    map: this.map,
                    container: 'viewDiv',
                    center: this.mapConfig.view.center,
                    zoom: this.mapConfig.view.zoom,
                    popup: {
                        dockEnabled: this.mapConfig.defaultDocked,
                        dockOptions: {
                            buttonEnabled: false,
                            position: "top-right"
                        },
                        highlightEnabled: false,
                        collapseEnabled: false
                    }
                });

                this.view.when(() => { 
                    this.search.focus();
                    let searchInput = document.querySelector(".esri-search__input");
                    if (this.smallLayout) {
                        searchInput.style.fontSize = "16px";
                    } // if

                    if (this.mapConfig.legend) {
                        this.legend = new Legend({
                            view : this.view,
                            style : "classic"
                        });
                        this.view.ui.add(this.legend, 'bottom-right');

                        this.legend.when(() => {
                            this.legend.activeLayerInfos.items[0].title = " ";
                            this.addActivityFeatures(FeatureLayer);
                        });
                    } // if
                })

                if (this.mapConfig.search) {
                    this.search = new Search({
                        sources: [{
                            layer: new FeatureLayer({
                                url: this.mapConfig.layers[3].data.url,
                                outFields: ["*"]
                            }),
                            searchFields: ["BrandonGIS.sde.OPENDATA_JSON_TAC.ADDRESS"],
                            displayField: "BrandonGIS.sde.OPENDATA_JSON_TAC.ADDRESS",
                            exactMatch: false,
                            outFields: ["*"],
                            name: "Street Address",
                            placeholder: "Enter address",
                            maxResults: 10,
                            suggestionsEnabled: true,
                            maxSuggestions: 5,
                            minSuggestCharacters: 1
                        },
                        {
                            layer: new FeatureLayer({
                                url: this.mapConfig.layers[3].data.url,
                                outFields: ["*"]
                            }),
                            searchFields: ["BrandonGIS.SDE.ownership.BROLL"],
                            displayField: "BrandonGIS.sde.OPENDATA_JSON_TAC.ADDRESS",
                            exactMatch: true,
                            outFields: ["*"],
                            name: "Roll Number",
                            placeholder: "Enter roll number",
                            maxResults: 5,
                            suggestionsEnabled: true,
                            maxSuggestions: 3,
                            minSuggestCharacters: 1
                        }],
                        allPlaceholder: this.smallLayout ? "Address or roll number" : "Find address or roll number",
                        includeDefaultSources: false,
                        autoSelect: false,
                        popupOpenOnSelect: false,
                        popupEnabled: true
                    });

                    this.search.on("search-complete", this.searchComplete);
                    this.search.on("search-clear", this.searchClear);
                    this.search.on("search-start", () => {
                        this.search.searchTerm = this.search.searchTerm.toUpperCase().replace(/[-_ ]+/g, ' ');
                    });

                    this.search.view = this.view;
                    this.search.container = document.getElementById("searchDiv");

                    if (!this.smallLayout) {
                        this.search.locationEnabled = false;
                    } // if
                } // if
                
                this.view.ui.move(["zoom"], "bottom-left");

                this.view.on("click", this.mapClick);                                

                this.view.popup.viewModel.watch("selectedFeature", this.selectedFeatureChange);
                
                if (this.mapConfig.triggerActions) {
                    if (this.smallLayout) {
                        this.view.popup.actions = [this.mapConfig.triggerActions.openSidebar];
                        this.view.popup.on("trigger-action", 
                            (event) => {
                                if (event.action.id === "open-sidebar") {
                                    this.$emit(event.action.id);
                                } // if
                            }
                        );
                    } // if
                } // if
                
                if (this.mapConfig.showToolbar) {
                    this.view.ui.add("toolbar", "top-left");

                    this.selectSketchVM = new SketchViewModel({
                        view: this.view,
                        layer: this.map.findLayerById("resultLayer"),
                        polygonSymbol: {
                            type: "simple-fill", // autocasts as new SimpleFillSymbol()
                            color: "rgba(138,43,226, 0.8)",
                            style: "solid",
                            outline: {
                            color: "white",
                            width: 1
                            }
                        },
                        updateOnGraphicClick: false
                    });

                    // The event name is "draw-complete" in API versions 4.7 or less (currently using 4.10)
                    this.selectSketchVM.on("create", this.selectFeatures);

                    document.getElementById("rectangleButton").onclick = () => {
                        if (!this.rectangleSelect) {
                            this.rectangleSelect = true;
                            this.selectSketchVM.create("rectangle");
                        } // if
                        else {
                            this.selectSketchVM.cancel();
                        } // else
                    };

                    document.getElementById("multiselectButton").onclick = () => { this.multiSelect = !this.multiSelect };
                    document.getElementById("clearButton").onclick = this.clearClick;
                } // if

                let gallery = new BasemapGallery({
                    view: this.view
                });

                new Expand({
                    expandIconClass: "esri-icon-basemap",
                    expandTooltip: "Show basemap gallery",
                    collapseTooltip: "Hide basemap gallery",
                    view: this.view,
                    content: gallery,
                    mode: "floating",
                    group: "mapTool",
                    container: "basemapDiv"
                });

                this.$emit('mapload-complete');
            } // loadMap()
        },
        data() {
            return {
                searchResults: [],
                view: {},
                map: null,
                search: {},
                legend: {},
                query: {},
                queryTask: {},
                rectangleSelect: false,
                multiSelect: false,
                gotoHighlight: false,
                print: {},
                interval: null
            }
        },
        mounted() {
           
        },
        beforeDestroy() {
            //Stop polling for live data
            clearInterval(this.interval);
        },
        watch: {
            checkedLayers: 'setLayers',
            listLane: 'listSelect',
            customQuery: 'runCustomQuery',
            configReady: 'loadMap',
            searchValue: 'runSearch',
            resetView: 'defaultView',
            selectionData: 'setCustomExportElements'
        }
    }; //export default
</script>
<style>
    @import url("https://js.arcgis.com/4.18/esri/css/main.css");

    #viewDiv {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }

    #toolbar {
        background: #78909c;
        padding: 4px;
        /* position: absolute;
        top: 15px;
        left: 15px; */
    }

    .toolbar-spacer {
        padding-left: 5px;
    }
    
    .esri-search {
        width: 270px;
        background:#78909c;
        padding: 4px;
    }

    .action-button {
        font-size: 16px;
        background-color: #fff;
        border: 1px solid #D3D3D3;
        color: #6e6e6e;
        height: 34px;
        width: 34px;
        text-align: center;
    }

    .action-button:hover {
        background: #f0f0f0;
        color: #000;
    }

    .action-button-toggle {
      background: #e0e0e0;
      color: #000;
    }

    .mapTool {
        font-size: 16px;
        border: 1px solid #D3D3D3;
        float: left;
    }
</style>